import React from "react";
import styles from "./greenheader.module.css";

function GreenHeader({ word }) {
  return (
    <div className={styles.box}>
      <div className={styles.word}>{word}</div>
    </div>
  );
}

export default GreenHeader;
